import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Collapse, Button } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaMapMarkerAlt, FaSlash, FaDrawPolygon, FaRegCircle, FaRegSquare } from 'react-icons/fa';
import './Nutrients.css';
const NutrientsItemView = ({ nutrientsItem, handleItemEditPopup, handleItemHighlight, handleNutrientDeletePopup }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const handleItemExpandCollapse = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    return (
        <Row>
            <Col>
                <Card className="my-3">
                    <CardHeader className="item-header" onClick={handleItemExpandCollapse}>
                        <Row>
                            <Col sm="1">
                                <a onMouseOver={(itemId) => handleItemHighlight(nutrientsItem.itemId)} onMouseOut={(itemId) => handleItemHighlight(0)}>
                                    {nutrientsItem.mapMarkerType == 'marker' ? <FaMapMarkerAlt color={nutrientsItem.colour}></FaMapMarkerAlt> :
                                        nutrientsItem.mapMarkerType == 'polyline' ? <FaSlash color={nutrientsItem.colour}></FaSlash> :
                                            nutrientsItem.mapMarkerType == 'polygon' ? <FaDrawPolygon color={nutrientsItem.colour}></FaDrawPolygon> :
                                                nutrientsItem.mapMarkerType == 'circle' ? <FaRegCircle color={nutrientsItem.colour}></FaRegCircle> :
                                                    nutrientsItem.mapMarkerType == 'rectangle' && <FaRegSquare color={nutrientsItem.colour}></FaRegSquare>}
                                </a>
                            </Col>
                            <Col sm="10"><h6 className="text-uppercase">{nutrientsItem.name}</h6></Col>
                            <Col sm="1" className="toggleoutline">
                                {
                                    isIconUp ?
                                        <FaChevronUp /> :
                                        <FaChevronDown />
                                }
                            </Col>
                        </Row>

                    </CardHeader>
                    <Collapse isOpen={isOpen}>
                        <CardBody>
                            <Row>
                                <Col>
                                    <div>Date: {nutrientsItem.date != null ? nutrientsItem.dateText:"" } </div>
                                    <div>LU: {nutrientsItem.lmuId != null ? nutrientsItem.lmuName : ""} </div>
                                </Col>
                                <Col>
                                    <div>Optimal Olsen P Range: {nutrientsItem.optimalRange} </div>
                                    <div>Latest Olsen P Range: {nutrientsItem.olsenpValueRange} </div>
                                </Col>
                                <Col>
                                    <Button id={nutrientsItem.itemId} color="warning" size="sm" onClick={(itemId) => handleItemEditPopup(nutrientsItem.itemId)}>Edit</Button>{' '}
                                    <Button id={nutrientsItem.itemId} color="danger" size="sm" onClick={(itemId) => handleNutrientDeletePopup(nutrientsItem.itemId)}>Delete</Button>{' '}
                                </Col>
                            </Row>
                        </CardBody>
                    </Collapse>
                </Card>
            </Col>
        </Row>
    )
}
export default NutrientsItemView;